import axios from 'axios';

export function getLoadingAndDischarging() {
    return axios({
        method: 'GET',
        url: '/api/v1/cargoassigner/ld',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function updateLoadingAndDischarging(item) {
    const data = {};
    data.loading = item.ldRates.loading;
    data.loading = {
        abbreviation: data.loading.abbreviation ? data.loading.abbreviation : '',
        cqd: data.loading.cqd,
        dimension: data.loading.dimension ? data.loading.dimension : '',
        speed: data.loading.speed ? data.loading.speed : '',
        term: data.loading.term ? data.loading.term : '',
    };
    data.discharging = item.ldRates.discharging;
    data.discharging = {
        abbreviation: data.discharging.abbreviation ? data.discharging.abbreviation : '',
        cqd: data.discharging.cqd,
        dimension: data.discharging.dimension ? data.discharging.dimension : '',
        speed: data.discharging.speed ? data.discharging.speed : '',
        term: data.discharging.term ? data.discharging.term : '',
    };

    return axios({
        method: 'PUT',
        url: `/api/v1/cargoassigner/ld/${item._id}`,
        data,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteLoadingAndDischarging(item) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/cargoassigner/ld/${item._id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/cargoes/ldRates.js